import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";
import getConnection from "@/utils/signalr_connection";

Vue.use(Vuex);
Vue.use(VueAxios, axios);

function loadUser() {
    const saved = localStorage.getItem("user");
    if (saved) {
        try {
            const user = JSON.parse(saved);
            setUserHeader(user);
            if (user && user.id) {
                try {
                    getConnection().start();
                } catch (e) {
                    setTimeout(() => getConnection().start(), 5000);
                }
            }
            return user;
        } catch (e) {
            console.log(e);
        }
    }
    return null;
}

function setUserHeader(user) {
    axios.interceptors.request.use((config) => {
        if (user) {
            config.headers["X-User"] = user.id;
        } else {
            //delete config.headers["X-User"];
        }
        return config;
    });
}

const store = new Vuex.Store({
    state: {
        user: loadUser(),
        pageSubtitle: "",
        menuCollapsed: false,
    },
    getters: {
        isAuthenticated: (state) => state.user,
    },
    mutations: {
        setUser: (store, data) => {
            store.user = data;
            setUserHeader(data);
            localStorage.setItem("user", JSON.stringify(data));
        },
        setPageSubtitle: (store, payload) => (store.pageSubtitle = payload),
        setMenuCollapsed: (store, payload) => (store.menuCollapsed = payload),
    },
    actions: {
        async login({ commit }, payload) {
            const { data } = await axios.post("/api/login", payload);
            await commit("setUser", data);
            try {
                getConnection().start();
            } catch (e) {
                setTimeout(() => getConnection().start(), 5000);
            }
        },
        logout({ commit }) {
            localStorage.removeItem("user");
            let connection = getConnection();
            if (connection) {
                connection.stop();
            }
            commit("setUser", null);
        },
    },
    modules: {},
});

export { store };
